export const USER_SETUP_REQUEST = "USER_SETUP_REQUEST";
export const USER_SETUP_SUCCESS = "USER_SETUP_SUCCESS";
export const USER_SETUP_FAILURE = "USER_SETUP_FAILURE";
export const RESET_USER_SETUP_STATE = "RESET_USER_SETUP_STATE";

